export const EmployeeNotesRoutes = [
    {
        "url": "/employee-card/:user_id?brandId&tab&view_status&expanded_tab",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.employee-card",
        "views": {
            "body": {
                "component": "employeeCardComponent",
            }
        },
        "route_styles": {
            styles: ["employee-card", 'employee-notes'],
            framework: "bootstrap_v4"
        },
        "params": {
            tab: {
                dynamic: true,
                value: "employeeInfo"
            },
            brandId: {
                dynamic: true
            },
            expanded_tab: {
                dynamic: true
            },
            user_id: {
                dynamic: true,
                value: ""
            },
            view_status: {
                dynamic: true,
                value: "ACTIVE"
            }
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/employee-notes/employee-notes.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=employee-notes.routes.js.map